import { RAG_COLORS, RAG_CLASSES } from '../constants';

// IB-677 rework — build RADIO donut segments / bar segments from the payload's
// {classification: count} objects, which the backend emits in R, A, G order.

const RAG_LABEL = () => ({ R: $t('Red'), A: $t('Amber'), G: $t('Green') });

export function ragTotal(counts) {
    return Object.values(counts || {}).reduce((carry, value) => carry + (Number(value) || 0), 0);
}

// Donut segments [{ value, colour, label }] — colour mapped by R/A/G insertion order.
export function ragDonutSegments(counts) {
    const labels = RAG_LABEL();

    return Object.entries(counts || {}).map(([key, value], index) => ({
        value: Number(value) || 0,
        colour: RAG_COLORS[index] || RAG_COLORS[RAG_COLORS.length - 1],
        label: `${labels[key] || key} · ${Number(value) || 0}`,
    }));
}

// HBars segments [{ value, colourClass }] from a {R, A, G} counts object.
export function ragBarSegments(counts) {
    return ['R', 'A', 'G'].map((key, index) => ({ value: Number(counts?.[key]) || 0, colourClass: RAG_CLASSES[index] }));
}
